import { Star, Quote } from "lucide-react";

export function Testimonials() {
    const testimonials = [
        { name: "Dra. Ana Silva", role: "Clínica Estética", text: "Em 30 dias minha agenda passou de 40% para 95% de ocupação. A IA atende perfeitamente meus pacientes." },
        { name: "Dr. Carlos Mendes", role: "Ortopedista", text: "Consegui triplicar meu faturamento em 3 meses. O método realmente funciona!" },
        { name: "Dra. Fernanda Lima", role: "Dermatologista", text: "Finalmente tenho previsibilidade. Sei exatamente quantos pacientes terei por mês." },
    ];

    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">O que dizem nossos clientes</h2>
                    <p className="text-slate-600 text-lg">Resultados reais de clínicas que transformaram seus negócios</p>
                </div>
                <div className="grid md:grid-cols-3 gap-8">
                    {testimonials.map((t, i) => (
                        <div key={i} className="bg-slate-50 rounded-2xl p-8 relative">
                            <Quote className="w-10 h-10 text-brand-200 absolute top-4 right-4" />
                            <div className="flex gap-1 mb-4">
                                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 text-yellow-400 fill-current" />)}
                            </div>
                            <p className="text-slate-700 mb-6">"{t.text}"</p>
                            <div>
                                <p className="font-bold text-slate-900">{t.name}</p>
                                <p className="text-slate-500 text-sm">{t.role}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
